export default {
  'apiPath': '/backend'
  // 'apiPath': 'https://localhost:44312'
};
